// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"75b943a6","140":"7d9b2729","468":"3977ea42","479":"603e4dc8","587":"319acc0a","606":"aa3eb68d","833":"ffceddcd","883":"67fb077e","965":"f08481c6","994":"8ad85eb0"}[chunkId] + ".chunk.css";
};